import React, { useEffect, useState } from "react";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
import './AdminTable.scss';
import { MDBBtn, MDBCheckbox, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import { LondonDate } from "../../Utils/utils";
import { useRef } from "react";

const AdminTable = React.memo((props) => {
    const now = LondonDate(new Date());
    const [sort, setSort] = useState(props.sort);
    const [search, setSearch] = useState(props.search);
    const {rows, renderTbodyTr} = props;
    const columns = props.columns.filter(col => col.disable != true);
    const [theadTranslateY, setTheadTranslateY] = useState(0);
    const tableRef = useRef(null);
    const tableTop = useRef(0);
    let timer1 = null;

    useEffect(()=>{
        const handleScroll = () => {  
            if(timer1) clearTimeout(timer1);
            timer1 = setTimeout(onScrollMove, 200);
        };
        window.addEventListener('scroll', handleScroll);
            
        return () => {  
            window.removeEventListener('scroll', handleScroll);  
        };
    }, [])

    useEffect(() => {
        if(tableRef.current) {
            const rect = tableRef.current.getBoundingClientRect(); 
            tableTop.current = rect.top;
        }
    }, [tableRef.current])

    const onScrollMove = () => {
        if(tableTop.current > 0) {
            if(window.scrollY > tableTop.current) {
                setTheadTranslateY(window.scrollY - tableTop.current - 5);
            } else {
                setTheadTranslateY(0);
            }
        }
        timer1 = null;
    }

    const clearSearch = () => {
        setSearch({});
        props.handleSearch && props.handleSearch({});
    }
    const handleSearch = () => {
        props.handleSearch && props.handleSearch(search);
    }
    const handleCheckChange = (e, col) => {
        setSearch({
            ...search,
            [col.name]: e.target.checked
        })
        col.search?.onChange && col.search?.onChange(e.target.checked)
    }
    const handleSelectChange = (opt, col) => {
        setSearch({
            ...search,
            [col.name]: {
                op: search[col.name]?.op ?? col.search.ops[0].value,
                value: opt.value
            }
        })
    }
    const handleOpSelectChange = (opt, col) => {
        setSearch({
            ...search,
            [col.name]: {
                ...search[col.name],
                op: opt.value
            }
        })
    }
    const handleDateChange = (d, col) => {
        setSearch({
            ...search,
            [col.name]: {
                op: search[col.name]?.op ?? col.search.ops[0].value,
                value: d
            }
        })
    }
    const handleInputChange = (e, col) => {
        const updated = {
            ...search,
            [e.target.name]: {
                op: search[e.target.name]?.op ?? col.search.ops[0].value,
                value: e.target.value
            }
        };
        setSearch(updated);
        if (props.autoSearch) {
            props.handleSearch && props.handleSearch(updated);
        }
    }
    const handleSort = (col, dir) => {
        const s = {
            name: col.name,
            dir
        };
        setSort(s);
        props.handleSort && props.handleSort(s);
    }

    const renderSearchCell = (col, colIndex) => {
        if(col.search?.enable) {
            switch(col.search.type) {
                case 'check':
                    return <div className="d-flex align-items-first">
                        <MDBCheckbox name={col.name} onChange={e=>handleCheckChange(e, col)} value={search[col.name] ?? false} />
                    </div>
                case 'date':
                    return (<>
                        <div style={{width: 230}}>
                            <Select 
                                options={col.search.ops} 
                                value={col.search.ops.find(opt=>opt.value == search[col.name]?.op)} 
                                onChange={(opt) => handleOpSelectChange(opt, col)} 
                            />
                        </div>                    
                        <DateTimePicker 
                            name={col.name}
                            className="mt-1" 
                            onChange={d=>handleDateChange(d, col)} 
                            value={search[col.name]?.value} 
                            format="y/MM/dd HH:mm:ss" 
                            disableClock={true} 
                        />
                    </>)
                case 'text':
                    return (<div style={{minWidth: 100}}>
                        <MDBInput type="text" name={col.name} value={search[col.name]?.value ?? ''} onChange={e=>handleInputChange(e, col)} />
                    </div>)
                case 'number':
                    return (<div style={{minWidth: 50}}>
                        <MDBInput type="number" name={col.name} value={search[col.name]?.value ?? ''} onChange={e=>handleInputChange(e, col)} />
                    </div>)
                case 'select':
                    return (<div style={{minWidth: 100}}>
                        <Select 
                            options={col.search.options} 
                            value={col.search.options.find(opt=>opt.value == (search[col.name]?.value ?? '') )} 
                            onChange={(opt)=>handleSelectChange(opt, col)} 
                        />
                    </div>)
            }
        }
    }

    const renderHeader = () => {
        return (
            <thead style={{transform: `translateY(${theadTranslateY}px)`, transition: 'all 0.3s'}}>
                <tr>
                    {columns.map((col, index) => {
                        let el = col.title;
                        return (
                            <th key={index} style={col.headerStyle} className={`${col.headerClassName ?? ''}`}>
                                <div className="d-flex align-items-center">
                                    {el}
                                    {col.sortable && <div className="d-flex flex-column ms-2">
                                        <MDBIcon 
                                            className={`sort-icon ${(sort?.name === col.name && sort?.dir === "ASC") ? 'active' : ''}`} 
                                            fas icon="caret-up" size="md" onClick={() => handleSort(col, 'ASC')} 
                                        />
                                        <MDBIcon 
                                            className={`sort-icon ${(sort?.name === col.name && sort?.dir === "DESC") ? 'active' : ''}`}
                                            fas icon="caret-down" size="md" onClick={() => handleSort(col, 'DESC')} 
                                        />
                                    </div>}
                                </div>
                            </th>
                        )
                    })}
                </tr>
                <tr className="search">
                    {columns.map((col, index) => {
                        if(col.name === 'action') {
                            return (<td key={index}>
                                <div className="d-flex justify-content-end align-items-center pe-2">
                                    <MDBBtn color="none" tag="a" onClick={handleSearch}><MDBIcon fas icon='search' size="lg" /></MDBBtn>
                                    <MDBBtn className="ms-2" color="none" tag="a" onClick={clearSearch}><MDBIcon fas icon='times' size="lg" /></MDBBtn>
                                </div>
                            </td>)
                        } else {
                            const el = renderSearchCell(col, index);
                            if(el) {
                                return <td key={index}>{el}</td>
                            } else {
                                return <td key={index}></td>
                            }
                        }
                    })}
                </tr>
            </thead>
        )
    }

    const renderBody = () => {
        if(rows?.length > 0) {
            return (
                <tbody>
                    {rows.map((row, rowIndex) => renderTbodyTr(row, rowIndex))}
                </tbody>
            )
        } else {
            return (
                <tbody>
                    <tr><td colSpan={columns.length} className="text-center">
                        No Data
                    </td></tr>
                </tbody>
            )
        }
    }

    return (
        <div className="admin-table-container">
            <table className="w-100 admin-table"  ref={tableRef} style={props.style}>
                {renderHeader()}
                {renderBody()}
            </table>
        </div>
    )
});

export default AdminTable;